import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import Swal from "sweetalert2";
import TableLoader from "../../Loader/TableLoader";
import axios from "axios";
import { API_BASE_URL } from "../../config";

const ManageCustomerMenu = () => {
  const [listPageData, setListPageData] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    fetchMenuList();
  }, []);

  // Fetch menu list
  const fetchMenuList = async () => {
    setIsLoading(true);
    try {
      const response = await axios.get(`${API_BASE_URL}/get-menu-list`, {
        headers: { "Content-Type": "application/json" },
      });
      setListPageData(response.data);
      setIsLoading(false);
    } catch (error) {
      console.error("Error fetching menu data:", error);
      setIsLoading(false);
    }
  };

  // Add Submenu using SweetAlert2
  const handleAddMenu = async () => {
    const { value: formValues } = await Swal.fire({
      title: "Add Menu",
      html: `
        <div style="text-align: left;">
          <label style="font-weight: bold;">Menu Name</label>
          <input id="swal-menu-name" class="form-control" placeholder="Enter menu name">
          
          <label style="font-weight: bold;">Menu Link</label>
          <input id="swal-menu-link" class="form-control" placeholder="Enter menu link">

          <label style="font-weight: bold;">Menu Icon</label>
          <input id="swal-menu-icon" class="form-control" placeholder="Enter menu icon">

          <label style="font-weight: bold;">Menu Order</label>
          <input id="swal-menu-order" type="number" class="form-control" placeholder="Enter menu order">
        </div>
      `,
      showCancelButton: true,
      confirmButtonText: "Add Menu",
      preConfirm: () => {
        return {
          menu_name: document.getElementById("swal-menu-name").value,
          menu_link: document.getElementById("swal-menu-link").value,
          menu_icon: document.getElementById("swal-menu-icon").value,
          menu_order: parseInt(
            document.getElementById("swal-menu-order").value,
            10
          ),
        };
      },
    });

    if (formValues) {
      if (
        !formValues.menu_name ||
        !formValues.menu_order
      ) {
        Swal.fire("Error", "All fields are required!", "error");
        return;
      }

      Swal.fire({
        title: "Adding Menu...",
        allowOutsideClick: false,
        didOpen: () => Swal.showLoading(),
      });

      const payload = {
        menu_name: formValues.menu_name,
        menu_link: formValues.menu_link,
        menu_icon: formValues.menu_icon,
        menu_order: formValues.menu_order,
      };

      try {
        await axios.post(`${API_BASE_URL}/menus`, payload, {
          headers: { "Content-Type": "application/json" },
        });

        Swal.fire("Success", "Menu added successfully!", "success");
        fetchMenuList();
      } catch (error) {
        console.error("Error adding menu:", error);
        Swal.fire("Error", "Failed to add menu", "error");
      }
    }
  };

  const handleEditMenu = async (menu) => {
    const { value: formValues } = await Swal.fire({
      title: "Add Menu",
      html: `
        <div style="text-align: left;">
          <label style="font-weight: bold;">Menu Name</label>
          <input id="swal-menu-name" class="form-control" value="${menu.menu_name}" placeholder="Enter menu name">
          
          <label style="font-weight: bold;">Menu Link</label>
          <input id="swal-menu-link" class="form-control" value="${menu.menu_link}" placeholder="Enter menu link">

          <label style="font-weight: bold;">Menu Icon</label>
          <input id="swal-menu-icon" class="form-control" value="${menu.menu_icon}" placeholder="Enter menu icon">

          <label style="font-weight: bold;">Menu Order</label>
          <input id="swal-menu-order" type="number" class="form-control" value="${menu.menu_order}" placeholder="Enter menu order">
        </div>
      `,
      showCancelButton: true,
      confirmButtonText: "Update Menu",
      preConfirm: () => {
        return {
          menu_name: document.getElementById("swal-menu-name").value,
          menu_link: document.getElementById("swal-menu-link").value,
          menu_icon: document.getElementById("swal-menu-icon").value,
          menu_order: parseInt(
            document.getElementById("swal-menu-order").value,
            10
          ),
        };
      },
    });

    if (formValues) {
      if (
        !formValues.menu_name ||
        !formValues.menu_link ||
        !formValues.menu_order
      ) {
        Swal.fire("Error", "All fields are required!", "error");
        return;
      }

      Swal.fire({
        title: "Updating Menu...",
        allowOutsideClick: false,
        didOpen: () => Swal.showLoading(),
      });

      const payload = {
        menu_name: formValues.menu_name,
        menu_link: formValues.menu_link,
        menu_icon: formValues.menu_icon,
        menu_order: formValues.menu_order,
      };

      try {
        await axios.put(`${API_BASE_URL}/menus/${menu.menu_id}`, payload, {
          headers: { "Content-Type": "application/json" },
        });

        Swal.fire("Success", "Menu Edited successfully!", "success");
        fetchMenuList();
      } catch (error) {
        console.error("Error adding menu:", error);
        Swal.fire("Error", "Failed to add menu", "error");
      }
    }
  };

  // Add Submenu using SweetAlert2
  const handleAddSubmenu = async (menuId) => {
    const { value: formValues } = await Swal.fire({
      title: "Add Submenu",
      html: `
        <div style="text-align: left;">
          <label style="font-weight: bold;">Submenu Name</label>
          <input id="swal-submenu-name" class="form-control" placeholder="Enter submenu name">
          
          <label style="font-weight: bold;">Submenu Link</label>
          <input id="swal-submenu-link" class="form-control" placeholder="Enter submenu link">

           <label style="font-weight: bold;">Submenu Icon</label>
          <input id="swal-submenu-icon" class="form-control" placeholder="Enter submenu icon">

          <label style="font-weight: bold;">Submenu Order</label>
          <input id="swal-submenu-order" type="number" class="form-control" placeholder="Enter submenu order">
        </div>
      `,
      showCancelButton: true,
      confirmButtonText: "Add Submenu",
      preConfirm: () => {
        return {
          sub_menu_name: document.getElementById("swal-submenu-name").value,
          sub_menu_link: document.getElementById("swal-submenu-link").value,
          sub_menu_icon: document.getElementById("swal-submenu-icon").value,
          sub_menu_order: parseInt(
            document.getElementById("swal-submenu-order").value,
            10
          ),
        };
      },
    });

    if (formValues) {
      if (
        !formValues.sub_menu_name ||
        !formValues.sub_menu_link ||
        !formValues.sub_menu_order
      ) {
        Swal.fire("Error", "All fields are required!", "error");
        return;
      }

      Swal.fire({
        title: "Adding Submenu...",
        allowOutsideClick: false,
        didOpen: () => Swal.showLoading(),
      });

      const payload = {
        menu_id: menuId,
        sub_menu_name: formValues.sub_menu_name,
        sub_menu_link: formValues.sub_menu_link,
        sub_menu_order: formValues.sub_menu_order,
        sub_menu_icon: formValues.sub_menu_icon,
      };

      try {
        await axios.post(`${API_BASE_URL}/sub-menus`, payload, {
          headers: { "Content-Type": "application/json" },
        });

        Swal.fire("Success", "Submenu added successfully!", "success");
        fetchMenuList();
      } catch (error) {
        console.error("Error adding submenu:", error);
        Swal.fire("Error", "Failed to add submenu", "error");
      }
    }
  };

  // Edit Submenu using SweetAlert2
  const handleEditSubmenu = async (submenu) => {
    const { value: formValues } = await Swal.fire({
      title: "Edit Submenu",
      html: `
        <div style="text-align: left;">
          <label style="font-weight: bold;">Submenu Name</label>
          <input id="swal-submenu-name" class="form-control" value="${submenu.sub_menu_name}" placeholder="Enter submenu name">
          
          <label style="font-weight: bold;">Submenu Link</label>
          <input id="swal-submenu-link" class="form-control" value="${submenu.sub_menu_link}" placeholder="Enter submenu link">

          <label style="font-weight: bold;">Submenu Icon</label>
          <input id="swal-submenu-icon" class="form-control" value="${submenu.sub_menu_icon}" placeholder="Enter submenu icon">

          <label style="font-weight: bold;">Submenu Order</label>
          <input id="swal-submenu-order" type="number" class="form-control" value="${submenu.sub_menu_order}" placeholder="Enter submenu order">
        </div>
      `,
      showCancelButton: true,
      confirmButtonText: "Update Submenu",
      preConfirm: () => {
        return {
          sub_menu_name: document.getElementById("swal-submenu-name").value,
          sub_menu_link: document.getElementById("swal-submenu-link").value,
          sub_menu_icon: document.getElementById("swal-submenu-icon").value,
          sub_menu_order: parseInt(
            document.getElementById("swal-submenu-order").value,
            10
          ),
        };
      },
    });

    if (formValues) {
      Swal.fire({
        title: "Updating Submenu...",
        allowOutsideClick: false,
        didOpen: () => Swal.showLoading(),
      });

      try {
        await axios.put(
          `${API_BASE_URL}/sub-menus/${submenu.sub_menu_id}`,
          formValues,
          { headers: { "Content-Type": "application/json" } }
        );

        Swal.fire("Updated!", "Submenu updated successfully!", "success");
        fetchMenuList();
      } catch (error) {
        console.error("Error updating submenu:", error);
        Swal.fire("Error", "Failed to update submenu", "error");
      }
    }
  };

  // Delete Submenu using SweetAlert2
  const handleDeleteSubmenu = async (subMenuId) => {
    Swal.fire({
      title: "Are you sure?",
      text: "This action cannot be undone!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, delete it!",
    }).then(async (result) => {
      if (result.isConfirmed) {
        Swal.fire({
          title: "Deleting Submenu...",
          allowOutsideClick: false,
          didOpen: () => Swal.showLoading(),
        });

        try {
          await axios.delete(`${API_BASE_URL}/sub-menus/${subMenuId}`, {
            headers: { "Content-Type": "application/json" },
          });

          Swal.fire("Deleted!", "Submenu has been removed.", "success");
          fetchMenuList();
        } catch (error) {
          console.error("Error deleting submenu:", error);
          Swal.fire("Error", "Failed to delete submenu", "error");
        }
      }
    });
  };

  // Delete Submenu using SweetAlert2
  const handleDeleteMenu = async (menuId) => {
    Swal.fire({
      title: "Are you sure?",
      text: "This action cannot be undone!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, delete it!",
    }).then(async (result) => {
      if (result.isConfirmed) {
        Swal.fire({
          title: "Deleting Menu...",
          allowOutsideClick: false,
          didOpen: () => Swal.showLoading(),
        });

        try {
          await axios.delete(`${API_BASE_URL}/menus/${menuId}`, {
            headers: { "Content-Type": "application/json" },
          });

          Swal.fire("Deleted!", "Submenu has been removed.", "success");
          fetchMenuList();
        } catch (error) {
          console.error("Error deleting menu:", error);
          Swal.fire("Error", "Failed to delete menu", "error");
        }
      }
    });
  };

  return (
    <div className="main-content">
      <div className="page-content">
        <div className="container-fluid">
          <div className="row">
            <div className="col-12">
              <div className="page-title-box d-sm-flex align-items-center justify-content-between">
                <h4 className="mb-sm-0 font-size-18">
                  Manage Customer Dashboard Menu
                </h4>
              </div>

              <div className="card">
                <div className="card-body rounded-3">
                  <div className="d-flex justify-content-between align-items-center mb-2">
                    <h4 className="card-title mb-2">Menu List</h4>
                    <div className="mb-2">
                      <button
                        type="button"
                        className="btn btn-success inner"
                        onClick={() => handleAddMenu()}
                      >
                        Add Menu <i className="fa fa-plus"></i>
                      </button>
                    </div>
                  </div>
                  <div className="table-responsive">
                    <table className="table align-middle table-nowrap mb-0">
                      <thead className="table-light">
                        <tr>
                          <th>Menu Name</th>
                          <th>Menu Icon</th>
                          <th>Menu Link</th>
                          <th>Actions</th>
                        </tr>
                      </thead>

                      <tbody>
                        {isLoading ? (
                          <TableLoader count={3} />
                        ) : listPageData?.data?.length > 0 ? (
                          listPageData?.data?.map((menuItem) => (
                            <React.Fragment key={menuItem.menu_id}>
                              <tr>
                                <td>
                                  <strong>{menuItem.menu_name}</strong>
                                </td>
                                <td>
                                  <i className={menuItem.menu_icon}></i>
                                </td>
                                <td>{menuItem.menu_link}</td>
                                <td>
                                  <button
                                    className="btn btn-primary btn-sm ms-2"
                                    onClick={() =>
                                      handleAddSubmenu(menuItem.menu_id)
                                    }
                                  >
                                    Add Submenu <i className="fa fa-plus"></i>
                                  </button>

                                  <button
                                    className="btn btn-primary btn-sm ms-2"
                                    onClick={() => handleEditMenu(menuItem)}
                                  >
                                    <i className="fa fa-pen"></i>
                                  </button>

                                  <button
                                    className="btn btn-danger btn-sm ms-2"
                                    onClick={() =>
                                      handleDeleteMenu(menuItem.menu_id)
                                    }
                                  >
                                    <i className="fa fa-trash"></i>
                                  </button>
                                </td>
                              </tr>

                              {menuItem?.sub_menus?.map((submenu) => (
                                <tr
                                  key={submenu.sub_menu_id}
                                  className="submenu-row"
                                >
                                  <td className="ps-4">
                                    ├── {submenu.sub_menu_name}
                                  </td>
                                  <td>
                                    <i className={submenu.sub_menu_icon}></i>
                                  </td>
                                  <td>{submenu.sub_menu_link}</td>
                                  <td>
                                    <button
                                      className="btn btn-primary btn-sm"
                                      onClick={() => handleEditSubmenu(submenu)}
                                    >
                                      <i className="fa fa-pen"></i>
                                    </button>
                                    <button
                                      className="btn btn-danger btn-sm ms-2"
                                      onClick={() =>
                                        handleDeleteSubmenu(submenu.sub_menu_id)
                                      }
                                    >
                                      <i className="fa fa-trash"></i>
                                    </button>
                                  </td>
                                </tr>
                              ))}
                            </React.Fragment>
                          ))
                        ) : (
                          <tr>
                            <td colSpan="4" className="text-center fw-bold">
                              No Data Found
                            </td>
                          </tr>
                        )}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ManageCustomerMenu;
